import React, { useState } from 'react';
import Table from '../../../../../components/ui/table';
import Button from '../../../../../components/ui/button';
import { formatCurrency, formatDate } from '../../../shared/constants';

const ExpenseTableClient = ({ expenses }) => {
	const [currentPage, setCurrentPage] = useState(1);
	const pageSize = 10;

	// Pagination
	const totalPages = Math.ceil(expenses.length / pageSize);
	const startIndex = (currentPage - 1) * pageSize;
	const paginatedExpenses = expenses.slice(startIndex, startIndex + pageSize);

	// Calculate total (ensure amounts are numeric)
	const total = expenses.reduce((sum, expense) => {
		const amount = typeof expense.amount === 'string' ? parseFloat(expense.amount) : expense.amount;
		return sum + (amount || 0);
	}, 0);

	return (
		<div className='bg-white rounded-lg border border-gray-200 overflow-hidden'>
			{/* Desktop Table View */}
			<div className='hidden md:block overflow-x-auto'>
				<Table>
					<Table.Header>
						<Table.Row>
							<Table.Head className='font-montserrat-medium'>Name</Table.Head>
							<Table.Head className='font-montserrat-medium'>Category</Table.Head>
							<Table.Head className='font-montserrat-medium'>Date</Table.Head>
							<Table.Head className='font-montserrat-medium'>Notes</Table.Head>
							<Table.Head className='font-montserrat-medium text-right'>
								Amount
			</Table.Head>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{paginatedExpenses.length > 0 ? (
							paginatedExpenses.map((expense) => (
								<Table.Row key={expense.id} className='hover:bg-gray-50'>
									<Table.Cell className='font-montserrat font-medium text-clientBlack whitespace-normal max-w-xs'>
										{expense.name}
									</Table.Cell>
									<Table.Cell className='font-montserrat text-gray-600 whitespace-normal'>
										{expense.category}
									</Table.Cell>
									<Table.Cell className='font-montserrat text-gray-600 whitespace-nowrap'>
										{formatDate(expense.date)}
									</Table.Cell>
									<Table.Cell className='font-montserrat text-gray-600 whitespace-normal min-w-[300px]'>
										{expense.notes || '-'}
									</Table.Cell>
									<Table.Cell className='font-montserrat-medium text-right text-clientBlack whitespace-nowrap'>
										{formatCurrency(expense.amount)}
									</Table.Cell>
								</Table.Row>
							))
						) : (
							<Table.Row>
								<Table.Cell
									colSpan={5}
									className='text-center py-8 text-gray-500 font-montserrat'>
									No expenses found for this period
								</Table.Cell>
							</Table.Row>
						)}
					</Table.Body>
				</Table>
			</div>

			{/* Mobile Card View */}
			<div className='md:hidden'>
				{paginatedExpenses.length > 0 ? (
					<div className='divide-y divide-gray-200'>
						{paginatedExpenses.map((expense) => (
							<div key={expense.id} className='p-4 hover:bg-gray-50'>
								<div className='space-y-2'>
									{/* Name */}
									<div className='font-montserrat-medium text-clientBlack text-base'>
										{expense.name}
									</div>

									{/* Category and Date */}
									<div className='flex items-center text-sm font-montserrat text-gray-600'>
										<span>{expense.category}</span>
										<span className='mx-2'>•</span>
										<span>{formatDate(expense.date)}</span>
									</div>

									{/* Notes */}
									{expense.notes && (
										<div className='font-montserrat text-sm text-gray-600'>
											{expense.notes}
										</div>
									)}

									{/* Amount */}
									<div className='font-montserrat-medium text-lg text-primary'>
										{formatCurrency(expense.amount)}
									</div>
								</div>
							</div>
						))}
					</div>
				) : (
					<div className='text-center py-8 text-gray-500 font-montserrat'>
						No expenses found for this period
					</div>
				)}
			</div>

			{/* Pagination */}
			{totalPages > 1 && (
				<div className='border-t border-gray-200 p-4 flex items-center justify-between'>
					<p className='text-sm font-montserrat text-gray-600'>
						Page {currentPage} of {totalPages}
					</p>
					<div className='flex gap-2'>
						<Button
							onClick={() => setCurrentPage(currentPage - 1)}
							disabled={currentPage === 1}
							variant='outline'
							size='sm'>
							Previous
						</Button>
						<Button
							onClick={() => setCurrentPage(currentPage + 1)}
							disabled={currentPage === totalPages}
							variant='outline'
							size='sm'>
							Next
						</Button>
					</div>
				</div>
			)}

			{/* Total */}
			<div className='border-t border-gray-200 bg-gray-50 px-4 py-3 flex justify-between items-center'>
				<p className='text-sm font-montserrat text-gray-600'>
					Total ({expenses.length} {expenses.length === 1 ? 'expense' : 'expenses'})
				</p>
				<p className='text-lg font-montserrat-medium text-clientBlack'>
					{formatCurrency(total)}
				</p>
			</div>
		</div>
	);
};

export default ExpenseTableClient;
